<template>
  <v-card class="w-[43rem]" flat>
    <!-- <div class="flex justify-between p-4 dark-bg-custom">
      <h4 class="">{{ editCase ? 'Edit Case' : 'Add Case' }}</h4>
      <v-icon @click="cancel">mdi-close</v-icon>
    </div> -->
    <div class="h-full overflow-visible">
      <ActitiveTabcomponent
        :tabs="mainTabs"
        :defaultTab="'addcase'"
        @tab-changed="onTabChanged"
        ref="tabComponent"
      >
        <template #tab-buttons>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <template #addcase>
          <div class="p-4 h-full">
            <v-form ref="form" v-model="valid" lazy-validation>
              <!-- Dynamic fields from baseFieldMappings when available -->

              <!-- Original hardcoded fields when no baseFieldMappings -->
              <template>
                <v-text-field
                  v-model="caseNo"
                  :label="configLang.caseNo?.displayName"
                  :rules="[(v) => !!v || `${configLang.caseNo?.displayName} is required`]"
                  v-show="configLang.caseNo?.formVisibility || configLang.caseNo?.displayName"
                  :disabled="!!configLang.caseNo?.isAutoGenerated"
                  outlined
                  dense
                />
                <v-text-field
                  v-model="typeOfLoan"
                  :label="configLang.typeOfLoan?.displayName || 'Type of loan'"
                  v-show="
                    configLang.typeOfLoan?.formVisibility || configLang.typeOfLoan?.displayName
                  "
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="bkt"
                  :label="configLang.bkt?.displayName || 'Bucket'"
                  v-show="configLang.bkt?.formVisibility || configLang.bkt?.displayName"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="pos"
                  :label="configLang.pos?.displayName || 'POS'"
                  v-show="configLang.pos?.formVisibility || configLang.pos?.displayName"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="emiAmount"
                  :label="configLang.emiAmount?.displayName || 'EMI Amount'"
                  v-show="configLang.emiAmount?.formVisibility || configLang.emiAmount?.displayName"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="tenure"
                  :label="configLang.tenure?.displayName || 'Tenure'"
                  v-show="configLang.tenure?.formVisibility || configLang.tenure?.displayName"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <!-- Dynamic fields from additionalColumns -->
              <template v-for="(field, key) in caseConfig.additionalColumns">
                <v-text-field
                  v-if="field.fieldType === 'STRING'"
                  :key="key + '-string'"
                  v-model="formData[key]"
                  :label="field.displayName"
                  :placeholder="`${field.displayName} (${field.fieldType})`"
                  outlined
                  dense
                />
                <v-text-field
                  v-else-if="field.fieldType === 'NUMBER'"
                  :key="key + '-number'"
                  v-model.number="formData[key]"
                  :label="field.displayName"
                  :placeholder="`${field.displayName} (${field.fieldType})`"
                  type="number"
                  outlined
                  dense
                />
                <v-menu
                  v-else-if="field.fieldType === 'DATE'"
                  :key="key + '-date'"
                  v-model="dateMenus[key]"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedDates[key]"
                      :label="field.displayName"
                      :placeholder="`${field.displayName} (${field.fieldType})`"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      clearable
                      @click:clear="clearDate(key)"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData[key]"
                    @input="formatDate(key)"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
                <v-select
                  v-else-if="field.fieldType === 'SELECT'"
                  :key="key + '-select'"
                  v-model="formData[key]"
                  :items="field.options || []"
                  :label="field.displayName"
                  :placeholder="`${field.displayName} (${field.fieldType})`"
                  outlined
                  dense
                ></v-select>
              </template>


              <!-- Hierarchical Search for Cross-linking -->
              <v-autocomplete
                v-if="caseConfig.crossLinkedSubCaseId || isCrossLinking"
                v-model="selectedLinkedItem"
                :label="`Search Linked Customer/Case`"
                :items="linkedItems"
                :loading="searchLoading"
                :search-input.sync="searchQuery"
                item-text="name"
                item-value="_id"
                return-object
                outlined
                dense
                hide-no-data
                placeholder="Search by Name, CRN or Case No"
                @update:search-input="debounceLinkedSearch"
                clearable
                @click:clear="clearLinkedSelection"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="font-bold">
                      {{ item.name }} ({{ item.mobile }})
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption grey--text">
                      {{ item.cases ? item.cases.length : 0 }} available cases to link
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>


              <!-- Standard Customer search (if NOT cross-linking) -->
              <v-autocomplete
                v-else
                v-model="customerId"
                :label="`Search ${configLang.customer?.displayName || 'Customer'}`"
                :items="customers"
                :item-text="getFullName"
                :search-input.sync="searchCustomer"
                item-value="_id"
                @update:search-input="debounceCustomer"
                hide-no-data
                outlined
                dense
              >
              </v-autocomplete>

              <!-- Selected Customer's Cases for Multi-linking -->
              <v-expand-transition>
                <div v-if="selectedLinkedItem && selectedLinkedItem.cases" class="mb-6">
                  <div class="text-subtitle-2 font-bold mb-2 blue-grey--text text--darken-3 px-1">
                    Select Cases to Link ({{
                      selectedLinkedItem.cases.filter((c) => c.selected).length
                    }})
                  </div>
                  <v-card outlined class="rounded-xl overflow-hidden">
                    <v-list dense class="pa-0">
                      <v-list-item
                        v-for="c in selectedLinkedItem.cases"
                        :key="c._id"
                        class="border-b last:border-0 py-1"
                      >
                        <v-list-item-action class="mr-4 my-0">
                          <v-checkbox
                            v-model="c.selected"
                            color="primary"
                            hide-details
                            @change="updateLinkedCaseIds"
                          ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">
                            Case No: {{ c.caseNo }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="text-caption">
                            Status: {{ c.status || 'Active' }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip x-small outlined color="primary" class="font-bold">
                            {{ c.useCase || 'Loan' }}
                          </v-chip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </div>
              </v-expand-transition>

              <!-- Entity autocomplete -->
              <v-autocomplete
                v-model="selectedEntity"
                :label="`Search ${caseConfig.entity?.displayName || 'Entity'}`"
                :items="entities"
                item-text="entityName"
                :search-input.sync="searchEntity"
                item-value="_id"
                @update:search-input="debounceEntity"
                hide-no-data
                outlined
                dense
                v-show="isEntityEnabled"
              >
              </v-autocomplete>

              <!-- Assigned To autocomplete -->
              <v-autocomplete
                v-model="assignedTo"
                :label="`Search ${configLang.assignedTo?.displayName || 'Assigned To'}`"
                :items="employees"
                :item-text="getEmpFullName"
                :search-input.sync="searchUser"
                item-value="_id"
                @update:search-input="debounceUser"
                hide-no-data
                v-show="
                  (configLang.assignedTo?.formVisibility || configLang.assignedTo?.displayName) &&
                  !editCase
                "
                hide-details
                outlined
                dense
              >
              </v-autocomplete>
            </v-form>
          </div>
        </template>
        <template #bulk>
          <GenericBulkUpload
            ref="bulkUploader"
            :title="`Bulk ${caseConfig.entity?.displayName || 'Case'}`"
            :subtitle="`Upload multiple ${
              caseConfig.entity?.displayName || 'Case'
            } using Excel file`"
            :entity-name="caseConfig.entity?.displayName || 'Case'"
            :required-columns="getRequiredCaseFields()"
            :upload-endpoint="'/collection/bulk'"
            method="post"
            :success-key="'collectionsProcessedSuccessfully'"
            :failed-key="'collectionProcessingFailed'"
            :invalid-items-key="'invalidCollections'"
            :sample-data="generateSampleData()"
            :additional-payload="getBulkUploadPayload()"
            :field-mappings="caseConfig.fieldMappings"
            :enableSave="false"
            :controlParentSaveButton="true"
            :case-config="caseConfig"
            @save-button-visibility="handleSaveButtonVisibility"
            @close="cancel"
            @downloadSample="exportXlsxFormat"
          />
        </template>
      </ActitiveTabcomponent>
      <div class="border-t p-4 bg-white">
        <div class="flex justify-end gap-3">
          <v-btn text class="font-size-sm normal-case" @click="cancel"> Cancel </v-btn>
          <v-btn
            v-if="showSaveButton"
            class="normal-case white--text"
            :color="$vuetify.theme.currentTheme.primary"
            @click="addCase"
          >
            <v-icon left>mdi-content-save</v-icon>
            Save
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import { fullName, debounce } from '@/utils/common'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import GenericBulkUpload from '../GenericBulkUpload.vue'
import { axiosUrl } from '@/utils/workforceApi'

export default {
  name: 'AddCases',
  data() {
    return {
      userData: this.$storage.getUniversal('user'),
      caseType: this.caseConfig.name,
      subCases: this.$store.state.subCases,
      // Fields for original implementation
      caseNo: '',
      typeOfLoan: '',
      bkt: '',
      pos: null,
      emiAmount: null,
      tenure: null,
      // Fields for dynamic implementation
      formData: {},
      // Date handling
      dateMenus: {},
      formattedDates: {},
      // Common fields
      customerId: null,
      searchCustomer: '',
      assignedTo: null,
      valid: true,
      customers: [],
      employees: [],
      searchUser: '',
      searchEntity: '',
      selectedEntity: null,
      // Partner search fields
      partnerId: null,
      searchPartner: '',
      partners: [],
      // Bulk upload related
      showSaveButton: true,
      // Cross-linking fields
      isCrossLinking: false,
      linkedCaseId: null,
      selectedLinkedItem: null,
      linkedItems: [],
      searchQuery: '',
      searchLoading: false
    }
  },
  components: {
    ActitiveTabcomponent,
    GenericBulkUpload
  },
  props: {
    editCase: Object,
    caseConfig: Object,
    entities: Array,
    restructuredData: Array
  },
  watch: {
    editCase: {
      handler(newVal) {
        this.editCase = newVal
        this.populate()
      },
      deep: true
    },
    selectedCustomer: {
      handler(val) {
        if (val) {
          this.customerId = val._id
        }
      }
    },
    selectedLinkedItem(val) {
      if (val && val.cases) {
        this.customerId = val._id
        // Initialize 'selected' property for cases if not present
        val.cases.forEach((c) => {
          if (c.selected === undefined) {
            this.$set(c, 'selected', true)
          }
        })
        this.updateLinkedCaseIds()
      } else {
        this.customerId = null
        this.formData.cross_case_linking = []
      }
    }
  },
  computed: {
    mainTabs() {
      const tabs = [
        {
          label: this.editCase ? 'Edit Case' : 'Add Case',
          key: 'addcase',
          icon: this.editCase ? 'mdi-pencil' : 'mdi-plus',
          component: 'AddEditCase'
        },
        {
          label: this.editCase ? 'Bulk Update' : 'Bulk Create',
          key: 'bulk',
          icon: 'mdi-upload',
          component: 'UploadCases'
        }
      ]

      return tabs
    },
    configLang() {
      return this.$props.caseConfig.fieldMappings
    },
    isEntityEnabled() {
      return this.caseConfig.entity?.enabled || false
    },
    caseAction() {
      if (this.editCase?._id) {
        return {
          action: 'UPDATE'
        }
      }
      return { action: 'CREATE' }
    }
  },
  methods: {
    exportXlsxFormat() {
      this.$emit('exportMappingFormat')
    },
    // Methods for GenericBulkUpload component
    getRequiredCaseFields() {
      // Extract required fields from caseConfig
      const requiredFields = []
      const fieldMappings = this.caseConfig?.fieldMappings || {}

      Object.entries(fieldMappings).forEach(([key, mapping]) => {
        if (mapping && mapping.displayName) {
          requiredFields.push(mapping.displayName)
        }
      })

      return requiredFields
    },

    generateSampleData() {
      // Generate sample data based on field mappings
      const sampleRows = []

      // Sample data for case bulk upload
      const sampleRow1 = {}
      const sampleRow2 = {}

      const fieldMappings = this.caseConfig?.fieldMappings || {}
      Object.entries(fieldMappings).forEach(([key, mapping]) => {
        if (mapping && mapping.displayName) {
          // Add sample values based on field type
          if (key === 'caseNo') {
            sampleRow1[mapping.displayName] = 'CASE001'
            sampleRow2[mapping.displayName] = 'CASE002'
          } else if (key === 'typeOfLoan') {
            sampleRow1[mapping.displayName] = 'Personal Loan'
            sampleRow2[mapping.displayName] = 'Home Loan'
          } else if (key === 'bkt') {
            sampleRow1[mapping.displayName] = 'BKT1'
            sampleRow2[mapping.displayName] = 'BKT2'
          } else if (key === 'pos') {
            sampleRow1[mapping.displayName] = '100000'
            sampleRow2[mapping.displayName] = '200000'
          } else if (key === 'emiAmount') {
            sampleRow1[mapping.displayName] = '5000'
            sampleRow2[mapping.displayName] = '10000'
          } else if (key === 'tenure') {
            sampleRow1[mapping.displayName] = '12'
            sampleRow2[mapping.displayName] = '24'
          } else {
            sampleRow1[mapping.displayName] = `Sample ${mapping.displayName} 1`
            sampleRow2[mapping.displayName] = `Sample ${mapping.displayName} 2`
          }
        }
      })

      sampleRows.push(sampleRow1, sampleRow2)
      return sampleRows
    },

    getBulkUploadPayload() {
      const payload = {
        caseType: this.caseConfig?.name,
        useCase: this.caseConfig?.useCase,
        subCaseId: this.caseConfig?._id
      }

      if (this.caseConfig?.branch) {
        payload.branch = this.caseConfig?.branch
      }

      return payload
    },


    debounceLinkedSearch: debounce(function (val) {
      if (val && val.length > 2) {
        this.fetchLinkedCustomers(val)
      }
    }, 500),

    async fetchLinkedCustomers(search) {
      this.searchLoading = true
      try {
        const linkedSubCase = this.subCases.find(
          (s) => s._id === this.caseConfig.crossLinkedSubCaseId
        )
        const { data } = await this.$axios.get('/customers/search-linked', {
          params: {
            search,
            useCase: linkedSubCase?.useCase || 'loan_management'
          }
        })
        this.linkedItems = data.data || []
      } catch (error) {
        console.error('Error fetching linked customers:', error)
      } finally {
        this.searchLoading = false
      }
    },

    clearLinkedSelection() {
      this.selectedLinkedItem = null
      this.formData.cross_case_linking = []
      this.customerId = null
    },

    updateLinkedCaseIds() {
      if (this.selectedLinkedItem && this.selectedLinkedItem.cases) {
        this.formData.cross_case_linking = this.selectedLinkedItem.cases
          .filter((c) => c.selected)
          .map((c) => c._id)

        // For backward compatibility with single link fields
        if (this.formData.cross_case_linking.length > 0) {
          this.linkedCaseId = this.formData.cross_case_linking[0]
        } else {
          this.linkedCaseId = null
        }
      }
    },

    handleSaveButtonVisibility(visible) {
      const activeTab = this.$refs.tabComponent?.activeTab || 'addcase'
      if (activeTab === 'bulk') {
        this.showSaveButton = visible
      } else {
        this.showSaveButton = true
      }
    },

    onTabChanged(tabKey) {
      if (tabKey === 'addcase') {
        this.showSaveButton = true
      }
    },

    async addCase() {
      try {
        const activeTab = this.$refs.tabComponent?.activeTab || 'addcase'
        if (activeTab === 'bulk') {
          this.$refs.bulkUploader?.processFile()
          return
        }
        if (!this.$refs.form) {
          this.$toast.error('Form is not available')
          return
        }

        const isValid = this.$refs.form.validate()
        if (!isValid) {
          this.$toast.error('Please fill the required fields')
          return
        }

        const payload = {
          caseType: this.caseType,
          caseNo: this.caseNo,
          typeOfLoan: this.typeOfLoan || undefined,
          bkt: this.bkt || undefined,
          pos: this.pos || undefined,
          emiAmount: this.emiAmount || undefined,
          tenure: this.tenure || undefined,
          customer: this.customerId,
          assignedTo: this.assignedTo,
          additionalColumns: this.formData,
          cross_case_linking: this.formData.cross_case_linking || []
        }

        if (this.$props.caseConfig?.branch) {
          payload.branch = this.$props.caseConfig?.branch
        }
        if (this.selectedEntity) {
          payload.entity = this.selectedEntity
        }
        if (this.caseConfig?._id) {
          payload.subCase = this.caseConfig?._id
          payload.useCase = this.caseConfig?.useCase
        }
        console.log(payload)
        // return

        let url = '/collection'
        let method = 'post'

        if (this.editCase) {
          method = 'put'
          url += `/${this.editCase._id}`
        }

        await this.$axios[method](url, payload)

        this.cancel()
      } catch (error) {
        this.$toast.error(error.response?.data?.message)
        console.error(error)
      }
    },
    debounceUser: debounce(async function (text) {
      if (!text || this.assignedTo) return true
      this.fetchUsers()
    }, 1000),
    async fetchUsers() {
      try {
        const params = {}
        if (this.searchUser) {
          params.search = this.searchUser
        }
        if (this.userData?.branch && !this.userData?.role?.includes('WFM_ADMIN')) {
          params.branch = this.userData?.branch
        }
        const response = await this.$axios.get(axiosUrl.users.getUsers, {
          params
        })
        this.employees = response.data?.users
      } catch (error) {
        console.log(error)
      }
    },
    debounceCustomer: debounce(async function (text) {
      if (!text || this.customerId) return true
      this.fetchCustomers()
    }, 800),
    async fetchCustomers() {
      try {
        const params = {}
        if (this.searchCustomer) {
          params.search = this.searchCustomer
        }
        const response = await this.$axios.get(axiosUrl.customers.getCustomers, {
          params
        })
        this.customers = response.data.customers
      } catch (error) {
        console.log(error)
        const errorMessage = error?.response?.data?.message || error
        this.$toast.error(errorMessage)
      }
    },
    debounceEntity() {
      this.$emit('emittedEntity', this.searchEntity)
    },
    getFullName(item) {
      return item.customerFullName
    },
    getEmpFullName(item) {
      return fullName(item)
    },
    getPartnerName(item) {
      return item.partnerName || 'Unknown Partner'
    },
    cancel() {
      this.resetForm()
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.$emit('caseAdded')
    },
    resetForm() {
      this.caseType = this.caseConfig.name
      this.partnerId = null
      this.searchPartner = ''

      this.caseNo = ''
      this.typeOfLoan = ''
      this.bkt = ''
      this.pos = null
      this.emiAmount = null
      this.tenure = null
      this.formData = {}
      this.formattedDates = {}
      this.dateMenus = {}
      this.initializeAdditionalColumns()
      this.autoGenerateCaseNo()
    },
    initializeAdditionalColumns() {
      if (this.caseConfig?.additionalColumns) {
        Object.keys(this.caseConfig.additionalColumns).forEach((key) => {
          this.$set(this.formData, key, null)
          if (this.caseConfig.additionalColumns[key].fieldType === 'DATE') {
            this.$set(this.dateMenus, key, false)
            this.$set(this.formattedDates, key, '')
          }
        })
      }
    },
    populate() {
      if (this.editCase) {
        this.caseType = this.editCase?.caseType

        // Populate original fields
        this.caseNo = this.editCase?.caseNo
        this.typeOfLoan = this.editCase?.typeOfLoan
        this.bkt = this.editCase?.bkt
        this.pos = this.editCase?.pos
        this.emiAmount = this.editCase?.emiAmount
        this.tenure = this.editCase?.tenure

        this.assignedTo = this.editCase?.assignedTo?._id
        this.customerId = this.editCase?.customer?._id
        this.selectedEntity = this.editCase?.entity?._id
        this.partnerId = this.editCase?.partner?._id

        if (this.editCase?.customer?.customerFullName) {
          this.searchCustomer = this.editCase?.customer?.customerFullName
          this.fetchCustomers()
        }
        if (this.editCase?.assignedTo?.firstName) {
          this.searchUser = this.editCase?.assignedTo?.firstName
          this.fetchUsers()
        }

        if (this.editCase?.additionalColumns) {
          this.formData = { ...this.formData, ...this.editCase.additionalColumns }
          // Format dates for the UI
          if (this.caseConfig?.additionalColumns) {
            Object.keys(this.caseConfig.additionalColumns).forEach((key) => {
              const field = this.caseConfig.additionalColumns[key]
              if (field.fieldType === 'DATE' && this.formData[key]) {
                this.formatDate(key)
              }
            })
          }
        }

        // Handle cross_case_linking population
        if (this.editCase?.cross_case_linking && this.editCase.cross_case_linking.length > 0) {
          const linkedIds = this.editCase.cross_case_linking.map((c) => c._id || c)
          this.$set(this.formData, 'cross_case_linking', linkedIds)

          if (this.editCase.customer) {
            this.fetchLinkedCustomerCases(this.editCase.customer._id, linkedIds)
          }
        }
      }
    },
    async fetchLinkedCustomerCases(customerId, linkedIds) {
      this.searchLoading = true
      try {
        const linkedSubCase = this.subCases.find(
          (s) => s._id === this.caseConfig.crossLinkedSubCaseId
        )
        // Use the customer's name to search so the API finds the record
        const { data } = await this.$axios.get('/customers/search-linked', {
          params: {
            search: this.editCase.customer.customerFullName,
            useCase: linkedSubCase?.useCase || 'loan_management'
          }
        })

        if (data.data && data.data.length > 0) {
          // Find the specific customer record by ID
          const customer = data.data.find((c) => (c._id || c) === customerId) || data.data[0]

          if (customer.cases) {
            customer.cases.forEach((c) => {
              if (linkedIds.includes(c._id)) {
                this.$set(c, 'selected', true)
              } else {
                this.$set(c, 'selected', false)
              }
            })
          }
          this.linkedItems = data.data || [customer]
          this.selectedLinkedItem = customer
          this.searchQuery = customer.name || customer.customerFullName
          this.updateLinkedCaseIds()
        }
      } catch (error) {
        console.error('Error fetching linked customer cases:', error)
      } finally {
        this.searchLoading = false
      }
    },
    formatDate(key) {
      this.formattedDates[key] = this.$dayjs(this.formData[key]).format('DD/MM/YYYY')
      this.dateMenus[key] = false
    },
    clearDate(key) {
      this.formData[key] = null
      this.formattedDates[key] = ''
    },
    autoGenerateCaseNo() {
      if (this.configLang?.caseNo?.isAutoGenerated && !this.editCase) {
        const prefix = this.configLang.caseNo.prefix || ''
        const timestamp = this.$dayjs().format('YYYYMMDD_HHmmss')
        this.caseNo = prefix ? `${prefix}_${timestamp}` : timestamp
      }
    }
  },
  async mounted() {
    this.initializeAdditionalColumns()
    this.populate()
    this.autoGenerateCaseNo()
  }
}
</script>
<style scoped>
/* Ensure form doesn't create its own scroll container */
.v-form {
  overflow: visible !important;
  max-height: none !important;
}

/* Ensure card content flows properly */
.v-card {
  overflow: visible !important;
}

/* Ensure autocomplete dropdowns work properly */
.v-autocomplete .v-menu__content {
  z-index: 999 !important;
}
</style>
